export default __webpack_public_path__ + "static/media/cha_healer_ansel.763f221b.png";